/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import BrandLogo from "@xo-union/component-brand-logo";
import { IconButton } from "@xo-union/tk-component-icons";
import { DisplayButton, DisplayLink } from "@xo-union/tk-ui-links";
import { useMobileMedia } from "@xo-union/tk-ui-breakpoints";
import styles from "./styles.css";
import CloseConfirmModal from "../CloseConfirmModal/index.js";
export default function Header(_ref) {
  var onQuitQuiz = _ref.onQuitQuiz,
    progressBar = _ref.progressBar,
    isModalOpen = _ref.isModalOpen,
    openModal = _ref.openModal,
    closeModal = _ref.closeModal;
  var media = useMobileMedia();
  return /*#__PURE__*/React.createElement("header", {
    className: styles['style-quiz-header-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['top-row']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['tk-logo-container'],
    "data-testid": "header-logo"
  }, /*#__PURE__*/React.createElement(BrandLogo, {
    name: "theknot",
    color: "primary",
    size: "lg",
    className: styles['tk-logo']
  })), media.yes ? /*#__PURE__*/React.createElement(IconButton, {
    "data-testid": "style-quiz-header-close-button",
    className: styles['close-button'],
    name: "close",
    size: "md",
    onClick: openModal
  }) : /*#__PURE__*/React.createElement(DisplayButton, {
    className: styles['close-button'],
    color: "primary",
    onClick: openModal,
    "data-testid": "style-quiz-header-close-button"
  }, "Close")), /*#__PURE__*/React.createElement("div", {
    className: "bottom-row",
    "data-testid": "style-quiz-progress-bar-container"
  }, progressBar), /*#__PURE__*/React.createElement(CloseConfirmModal, {
    isOpen: isModalOpen,
    onCloseModal: closeModal,
    onQuitQuiz: onQuitQuiz
  }));
}
process.env.NODE_ENV !== "production" ? Header.propTypes = {
  onQuitQuiz: PropTypes.func.isRequired,
  progressBar: PropTypes.node.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
} : void 0;